import React, { useEffect, useRef, useState } from 'react';
import { Button, Typography, useMediaQuery } from '@mui/material';
import { CDN_HOME_CLUBS } from '../../api/endpoint';
import axios from 'axios';
import createAxiosInstance from '../../api/axiosConfig';
import { useNavigate } from 'react-router-dom';
import rank from '../../assets/rank.png';

const Clubs = () => {
  const [stopExecution, setStopExecution] = useState<boolean | null>(false);
  const isFetching = useRef(false);
  const [clubs, setClubs] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState<string | null>(null);
  const isMobile = useMediaQuery('(max-width:600px)');
  const navigate = useNavigate();
  const fetchClubs = async () => {
    if (!stopExecution) {
      if (isFetching.current) return;
      isFetching.current = true;

      try {
        const axiosInstance = createAxiosInstance(true);
        const response = await axiosInstance.get(CDN_HOME_CLUBS, {});
        if (!response?.data?.data?.length) {
          setStopExecution(true);
        }
        setClubs((prevChamps: any) => [...prevChamps, ...response.data.data]);
        setCurrentPage(response.data.page);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          setError(error.message);
        }
      } finally {
        setLoading(false);
        isFetching.current = false;
      }
    }
  };
  const handleClubs = (clubs: any) => {
    navigate(`/club/${clubs.club_id}`, {
      state: { clubs }
    });
  };

  useEffect(() => {
    fetchClubs();
  }, []);

  return (
    <div style={{ margin: isMobile ? '3rem 0' : '5rem  0' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          flexWrap: isMobile ? 'wrap' : 'nowrap'
        }}>
        <Typography
          sx={{
            color: 'white',
            letterSpacing: isMobile ? 1 : 3,
            marginBottom: isMobile ? 2 : 5,
            fontFamily: 'Baloo2',
            fontSize: isMobile ? '24px' : '48px',
            fontWeight: 800,
            textAlign: isMobile ? 'left' : 'center',
            flex: 1,
            paddingLeft: '10rem'
          }}>
          {'Popular clubs'}
        </Typography>

        <Button onClick={() => navigate('/clubs')} sx={{ textTransform: 'none' }}>
          <Typography
            sx={{
              fontWeight: 400,
              color: 'white',
              fontFamily: 'Baloo2',
              fontSize: isMobile ? '12px' : '21px',
              padding: '0 10px'
            }}>
            view all
          </Typography>
        </Button>
      </div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '18px',
          margin: isMobile ? '0 10%' : '0 2%'
        }}>
        {clubs.map((item: any, index: number) => (
          <div
            key={index}
            style={{
              flex: isMobile ? '1 1 calc(100% / 3 - 18px)' : '1 1 calc(100% / 6 - 21px)',
              maxWidth: isMobile ? 'calc(100% / 3 - 16px)' : 'calc(100% / 6 - 16px)',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
            <Button onClick={() => handleClubs(item)} style={{ position: 'relative', padding: 0 }}>
              {/* Avatar Image */}
              <img
                src={`${process.env.REACT_APP_DEFAULT_AVATAR}/APP/ClubAvatars/${item.avatar}`}
                style={{
                  width: isMobile ? '98px' : '181px',
                  height: isMobile ? '91px' : '170px',
                  borderRadius: '8px'
                }}
                alt={item.title}
              />

              {/* Rank Image Positioned Over Avatar */}
              <img
                src={rank}
                alt="rank"
                style={{
                  position: 'absolute',
                  top: '34%',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: isMobile ? '30px' : '45px',
                  height: isMobile ? '30px' : '45px',
                  zIndex: 1
                }}
              />

              {/* Text Over Rank Image */}
              <span
                style={{
                  position: 'absolute',
                  top: isMobile ? '36px' : '40%',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  fontSize: isMobile ? '10px' : '14px',
                  fontWeight: 'bold',
                  color: '#fff',
                  zIndex: 2,
                  pointerEvents: 'none'
                }}>
                {item.condition}
              </span>
            </Button>

            {/* Club Name */}
            <Typography
              style={{
                fontSize: isMobile ? '13px' : '24px',
                fontFamily: 'Baloo2',
                fontWeight: 700,
                color: 'white'
              }}>
              {item.name}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Clubs;
